const CommonProps = {
    ACTION_INF: 'actionInf',
    ON_LAYER_DRAW: 'onLayerDraw',
    MATRIX_CREATED: 'matrixCreated'
};

export default CommonProps;
